import React from "react";
import ScannerView from "./ScannerView";
import QRCodeGuide from "./QRCodeGuide";

import BarcodeDetector from "barcode-detector"

// polyfill unless already supported
if (!window.BarcodeDetector) {
    window.BarcodeDetector = BarcodeDetector
}

function computeGuidePosition(videoWidth, videoHeight){
    const {innerWidth, innerHeight} = window
    const wScale = innerWidth / videoWidth, hScale = innerHeight / videoHeight
    const scale = wScale > hScale ? wScale : hScale
    videoWidth *= scale
    videoHeight *= scale
    const size = (videoWidth > videoHeight ? videoHeight : videoWidth) * 2 / 3
    return {
        x: (innerWidth - size) * 0.5,
        y: (innerHeight - size) * 0.5,
        size: size
    }
}

export default class QRCodeScanner extends React.Component{
    constructor(props) {
        super(props);
        this.canvas = React.createRef()
        this.state = {
            width: 0,
            height: 0,
            size: 0
        }
        const scanner = new window.BarcodeDetector(props.formats)

        this.setVideo = video => {
            this.video = video
            navigator.mediaDevices.getUserMedia({
                audio: false,
                video: {
                    facingMode: "environment"
                }
            }).then(stream => video.srcObject = stream)
        }

        const logError = error => console.log(error)

        const checkResults = results => {
            if (results.length){
                console.log(results[0].rawValue)
                this.props.onResult(results[0].rawValue)
            }
            else{
                poll()
            }
        }

        const image = new Image();
        image.addEventListener('load', () => scanner.detect(image).then(checkResults).catch(logError))

        const processBlob = blob => {
            if (this.objectUrl){
                URL.revokeObjectURL(this.objectUrl)
            }
            this.objectUrl = URL.createObjectURL(blob)
            image.src = this.objectUrl
        }

        const scanFrame = () => {
            const canvas = this.canvas.current
            if (!canvas){
                return
            }
            const {width, height, size} = this.state
            canvas.getContext('2d').drawImage(
                this.video, (width - size) * 0.5, (height - size) * 0.5,
                size, size, 0, 0, size, size
            )
            canvas.toBlob(processBlob)
        }

        const poll = () => this.pollHandle = setTimeout(scanFrame, 100)

        this.videoStarted = settings => {
            const {width, height} = settings
            const size = (width > height ? height : width) * 2 / 3
            this.setState({
                guidePosition: computeGuidePosition(width, height),
                width: width,
                height: height,
                size: size
            })
            poll()
        }
    }

    componentWillUnmount() {
        if (this.pollHandle){
            clearTimeout(this.pollHandle)
        }
        if (this.objectUrl){
            URL.revokeObjectURL(this.objectUrl)
        }
    }

    guide(){
        const {x, y, size} = this.state.guidePosition
        return <QRCodeGuide
            style={{
                position: "absolute",
                top: y,
                left: x,
                width: size,
                height: size
            }}
        />
    }

    render() {
        const {guidePosition, size} = this.state
        return <ScannerView onSettings={this.videoStarted} onVideo={this.setVideo} onClose={this.props.onClose}>
            {guidePosition ? this.guide() : null}
            <canvas ref={this.canvas} width={size} height={size} style={{
                position: "fixed",
                top: -size,
                left: -size
            }}/>
        </ScannerView>
    }
}
